module.exports = __webpack_public_path__ + "static/img/growing-plant.cdf7b183.svg";